import { IntegrationType } from "~graphql/sdk";
import { BuyNowPayLaterConfig } from "./checkout.types";
import { SystemProps } from "flicket-ui";

export const DEBIT_DISPLAY_NAME = "Debit / credit card";

export const LAYBUY_CONFIG: BuyNowPayLaterConfig = {
  terms: 6,
  period: "week",
  icon: "laybuy",
  brandColour: "#786dff",
};

export const AFTERPAY_CONFIG: BuyNowPayLaterConfig = {
  terms: 4,
  period: "fortnight",
  icon: "afterpay",
  brandColour: "#9DDFE8",
};

export const BNPL_CONFIG = {
  [IntegrationType.PaymentLaybuy]: LAYBUY_CONFIG,
  [IntegrationType.PaymentAfterpay]: AFTERPAY_CONFIG,
} as const;

export const PARTIAL_POINT_PAYMENT_TYPES = [
  IntegrationType.PaymentStripe,
  IntegrationType.PaymentPin,
  IntegrationType.PaymentWindcave,
  IntegrationType.PaymentLaybuy,
  IntegrationType.PaymentAfterpay,
  IntegrationType.PaymentMpaisa,
];

/**
 * Payment gateways that redirect to an external page for payment processing
 * These gateways don't use Stripe elements and instead redirect to their own hosted payment forms
 */
export const REDIRECT_PAYMENT_TYPES = [
  IntegrationType.PaymentPin,
  // Add other redirect-based gateways here as needed
];

export const singlePageCheckoutHeaderHeight: SystemProps["height"] = "64px";
export const singlePageCheckoutMaxWidth: SystemProps["maxWidth"] = {
  md: "960px",
  lg: "1120px",
};
export const singlePageCheckoutPaddingLeft: SystemProps["pl"] = { _: 3, md: 0 };
export const singlePageCheckoutPaddingRight: SystemProps["pr"] = {
  _: 3,
  md: 4,
};
